<template>
  <div ref="root" class="v5-pop-wrap v5-streak">
    <button
      class="v5-ib"
      type="button"
      :aria-label="t('v5.shell.streak_label', { n: days })"
      :aria-expanded="String(open)"
      aria-controls="v5-streak"
      @click="toggle"
    >
      <BoltIcon class="i" :class="{ 'is-on': days > 0 }" aria-hidden="true" /><span class="num">{{ days }}</span>
    </button>
    <div v-if="open" id="v5-streak" class="v5-pop v5-streak__pop">
      <p class="v5-streak__big">
        <BoltIcon class="i is-on" aria-hidden="true" />{{ t('v5.shell.streak_days', { n: days }) }}
      </p>
      <p>{{ t('v5.shell.streak_hint') }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { BoltIcon } from '@heroicons/vue/24/outline';
import usePopover from './usePopover';

// The classic Streaks badge: user.activity_streak, the days in a row a server was started
const props = defineProps({ user: { type: Object, required: true } });
const { t } = useI18n();
const { open, root, toggle } = usePopover();
const days = computed(() => props.user.activity_streak || 0);
</script>
